import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

export default class ScrollToBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.scrollTo = {
            update: (element: HTMLElement, valueAccessor: () => any) => {
                let value = ko.utils.unwrapObservable(valueAccessor());

                if (!isNaN(value)) {
                    $(element).animate({
                        scrollTop: value + 'px'
                    }, 'fast');
                }
            }
        };
    }
}